<div *ngIf="isLoading.contract" class="m-page-loader m-page-loader--non-block m-page-loader--absolute">
  <div class="m-loader m-loader--brand"></div>
</div>
<ng-container *ngIf="!isLoading.contract">
  <div class="m-subheader" style="position: relative;">
    <div class="d-flex align-items-center" style="flex-wrap: wrap;">
      <div class="mr-auto">
        <ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
          <li class="m-nav__item m-nav__item--home">
            <a routerLink="/" class="m-nav__link m-nav__link--icon">
              <i class="m-nav__link-icon la la-home"></i>
            </a>
          </li>
          <li class="m-nav__separator">
            -
          </li>
          <li class="m-nav__item">
            <a (click)="goBack()" class="m-nav__link">
            <span class="m-nav__link-text">
              {{ 'return' | transloco }}
            </span>
            </a>
          </li>
          <li class="m-nav__separator">
            -
          </li>
          <li class="m-nav__item">
            <span class="m-nav__link-text">{{ contract?.number }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="m-content">
    <!--Begin::Main Portlet-->
    <div class="row">
      <div class="col-sm-12">
        <div class="m-portlet m-portlet--head-solid-bg">
          <div class="m-portlet__head" style="position: relative;">
            <div [ngClass]="{'invisible': (contract | json) === '{}'  && isLoading.contract }"
                 class="m-portlet__head-caption">
              <div class="m-portlet__head-title">
                <h3 class="m-portlet__head-text">
                  {{ 'contract.title' | transloco }} {{ contract?.number }} {{ 'contract-view.from' | transloco }} {{ contract?.date | date: 'dd.MM.yyyy' }}
                </h3>
              </div>
            </div>

            <div *ngIf="!contract && isLoading.contract"
                 class="m-page-loader m-page-loader--non-block m-page-loader--absolute">
              <div class="m-loader m-loader--brand"></div>
            </div>
          </div>

          <div class="m-portlet__body">
            <div *ngIf="(contract | json) !== '{}'  && !isLoading.contract" class="row">
              <div class="col-md-12">

                <div class="form-group m-form__group row">
                  <div class="col-lg-2 col-md-3 col-sm-12">
                    {{ 'contract.organziation' | transloco }}:
                  </div>

                  <div class="col-lg-10 col-md-9 col-sm-12">
                  <span class="h5 m--font-success">
                    {{ contract?.organization?.title | uiLabel }}
                  </span>
                  </div>
                </div>

                <div class="form-group m-form__group row">
                  <div class="col-lg-2 col-md-3 col-sm-12">
                    {{ 'contract.supplier' | transloco }}:
                  </div>

                  <div class="col-lg-10 col-md-9 col-sm-12">
                    <div>
                      {{ contract?.supplier?.name }} ({{ contract?.supplier?.uin }})
                    </div>
                  </div>
                </div>

                <div class="form-group m-form__group row" *ngIf="contract?.bank">
                  <div class="col-lg-2 col-md-3 col-sm-12">
                    {{ 'contract.bank' | transloco }}:
                  </div>

                  <div class="col-lg-10 col-md-9 col-sm-12">
                    <div>
                      {{ contract?.bank?.name }} ({{ contract?.bank?.bic }})
                    </div>
                  </div>
                </div>

                <div class="form-group m-form__group row" *ngIf="contract?.iban">
                  <div class="col-lg-2 col-md-3 col-sm-12">
                    {{ 'contract.iban' | transloco }}:
                  </div>

                  <div class="col-lg-10 col-md-9 col-sm-12">
                    <div>
                      {{ contract?.iban }}
                    </div>
                  </div>
                </div>

                <div class="form-group m-form__group row">
                  <div class="col-lg-2 col-md-3 col-sm-12">
                    {{ 'contract.number' | transloco }}:
                  </div>

                  <div class="col-lg-10 col-md-9 col-sm-12">
                    <div>
                      {{ contract?.number }}
                    </div>
                  </div>
                </div>

                <div class="form-group m-form__group row">
                  <div class="col-lg-2 col-md-3 col-sm-12">
                    {{ 'contract.date' | transloco }}:
                  </div>

                  <div class="col-lg-10 col-md-9 col-sm-12">
                    <div>
                      {{ contract?.date | date: 'dd.MM.yyyy' }}
                    </div>
                  </div>
                </div>

                <div class="form-group m-form__group row">
                  <div class="col-lg-2 col-md-3 col-sm-12">
                    {{ 'contract.name' | transloco }}:
                  </div>

                  <div class="col-lg-10 col-md-9 col-sm-12">
                    {{ contract?.title }}
                  </div>
                </div>

                <div class="form-group m-form__group row">
                  <div class="col-lg-2 col-md-3 col-sm-12">
                    {{ 'contract.currency' | transloco }}:
                  </div>

                  <div class="col-lg-10 col-md-9 col-sm-12">
                    {{ contract?.currency }}
                  </div>
                </div>

                <div class="form-group m-form__group row">
                  <div class="col-lg-2 col-md-3 col-sm-12">
                    {{ 'contract.dueDays' | transloco }}:
                  </div>

                  <div class="col-lg-10 col-md-9 col-sm-12">
                    {{ contract?.dueDays }}
                  </div>
                </div>

                <div *ngIf="contract?.note" class="form-group m-form__group row">
                  <div class="col-lg-2 col-md-3 col-sm-12">
                    {{ 'contract.note' | transloco }}:
                  </div>

                  <div class="col-lg-10 col-md-9 col-sm-12">
                    {{ contract?.note }}
                  </div>
                </div>

                <table class="table m--margin-bottom-0" *ngIf="contract?.files && contract?.files.length > 0">
                  <thead class="thead-default">
                  <tr>
                    <th>{{ 'contract.files' | transloco }}</th>
                  </tr>
                  </thead>
                </table>
                <div class="is--responsive-table">
                  <div class="m-widget4 m-widget4--padding" *ngIf="contract?.files.length > 0">
                    <div class="m-widget4__item" *ngFor="let file of contract?.files">
                      <a *ngIf="file.mimeType !== 'application/pdf'" class="m-widget4__img m-widget4__img--icon"
                         (click)="showImage(file)">
                        <img [src]="baseLink + file.guid" [alt]="file.fileName">
                      </a>
                      <a *ngIf="file.mimeType === 'application/pdf'" class="m-widget4__img m-widget4__img--icon"
                         (click)="showImage(file)">
                        <i class="la la-file-pdf-o la-2x"></i>
                      </a>
                      <div class="m-widget4__info" [title]="file.fileName">
                          <span class="m-widget4__text">
                            {{ file.fileName }}
                          </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="(contract | json) === '{}' && isLoading.contract"
                 class="m-page-loader m-page-loader--non-block m-page-loader--relative">
              <div class="m-loader m-loader--brand"></div>
            </div>
          </div>
        </div>

        <a routerLink="../" class="is--cursor-pointer">
          ← {{ 'invoice.back' | transloco }}
        </a>
      </div>
    </div>
    <!--End::Main Portlet-->
  </div>
</ng-container>
<ng-template #templateRef let-modal>
  <div class="modal-header">
    <h3 class="modal-title">{{ image?.name }}</h3>
    <button class="close" type="button" (click)="closeModal(modal)"></button>
  </div>

  <div class="modal-body text-center">
    <iframe *ngIf="image.mimeType === 'application/pdf'" class="iframe" width="100%" height="100%" [src]="image.path"
            frameborder="0"></iframe>
    <img *ngIf="image.mimeType !== 'application/pdf'" [src]="image.path" [alt]="image?.name"
         style="max-width: 100%;">
  </div>
</ng-template>
